import React from "react";
import { useAppSettings } from "../../context/AppSettingsContext";
import "./globalBanner.styles.scss";

const GlobalBanner = () => {
  const { globalBannerMessage } = useAppSettings();

  if (!globalBannerMessage || !globalBannerMessage.trim()) {
    return null;
  }

  return (
    <div className="global-banner" role="status">
      <p className="global-banner__message">{globalBannerMessage}</p>
    </div>
  );
};

export default GlobalBanner;
